import React from "react";
import { View } from "react-native";
import { styles } from "./Divider.styles";
export const Divider = ({ color = "brand", containerStyles, }) => {
    return (React.createElement(View, { style: [styles.container, containerStyles] },
        React.createElement(View, { style: [styles.divider, styles[color]] }),
        React.createElement(View, { style: [styles.circle, styles[color]] }),
        React.createElement(View, { style: [styles.circle, styles.circleRight, color && styles[color]] })));
};
//# sourceMappingURL=Divider.js.map